<div class="lp-progress-bar">
  <div [style.background]="mainColor" [style.width]="value + '%'" class="lp-progress-value"></div>
</div>
